import { render, staticRenderFns } from "./pay-code.vue?vue&type=template&id=a4ec7ce0&scoped=true"
import script from "./pay-code.vue?vue&type=script&lang=js"
export * from "./pay-code.vue?vue&type=script&lang=js"
import style0 from "./pay-code.vue?vue&type=style&index=0&id=a4ec7ce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ec7ce0",
  null
  
)

export default component.exports